import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { environment } from 'src/environments/environment';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';
import { DropdownToggleDirective } from './../../../directives/dropdown-toggle.directive';

@Component({
  selector: 'app-filtro-tipo-obra-industrial',
  standalone: true,
  imports: [CommonModule, DropdownToggleDirective, FormsModule],
  templateUrl: './filtro-tipo-obra-industrial.component.html',
  styleUrls: ['./filtro-tipo-obra-industrial.component.scss'],
})
export class FiltroTipoObraIndustrialComponent implements OnInit {
  @Input() bloqueandoAtualizacao: boolean = false;
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  filtroTipoObra: Array<any> = [];
  @Input() idModuloSelecionado: number;
  @Input() tiposObraSelecionados: any[] = [];
  @Output() tipoObraChange = new EventEmitter<any[]>();
  @Input() disabled: boolean = false;

  private subscriptions = new Subscription();
  private jaCarregou = false;

  constructor(
    private readonly _filtroBuscaService: FiltroBuscaService,
    private readonly _errorHandleService: ErrorHandleService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (this.idModuloSelecionado === 234 || this.bloqueandoAtualizacao) {
      return;
    }
    if (changes.idModuloSelecionado || !this.jaCarregou) {
      this.jaCarregou = true;
      this.tipoDeObra();
    }
    if (changes.tiposObraSelecionados && this.filtroTipoObra.length > 0) {
      this.sincronizarTiposObraSelecionados();
    }
  }

  sincronizarTiposObraSelecionados() {
    if (!Array.isArray(this.tiposObraSelecionados)) return;
    const selecionadosIds = this.tiposObraSelecionados.map((t) => t.id);
    this.filtroTipoObra.forEach((item) => {
      item.checked = selecionadosIds.includes(item.id);
    });
  }

  onTipoObraChange() {
    const selecionados = this.filtroTipoObra.filter((o) => o['checked']);
    this.tipoObraChange.emit(selecionados);
  }

  tipoDeObra() {
    this.subscriptions.add(
      this._filtroBuscaService
        .filtroTiposObras(this.idModuloSelecionado)
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.filtroTipoObra = res.data;
              this.sincronizarTiposObraSelecionados();
              this._errorHandleService.throwConsoleError(res.message);
            }
          },
          error: (err) => {
            console.error('Erro na API:', err);
            this._errorHandleService.throwConsoleError('Erro ao buscar dados.');
          },
        })
    );
  }
}
